import React, { useState } from 'react';
import './CaseCreator.css';

const CaseCreator = ({ onClose, onCreated }) => {
  const [title, setTitle] = useState('');
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // Implement case creation logic here
    onCreated({ id: Date.now(), title, status: 'OPEN' });
  };

  return (
    <div className="case-creator">
      <h3>Create New Case</h3>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Case title"
        />
        <div className="buttons">
          <button type="submit">Create</button>
          <button type="button" onClick={onClose}>Cancel</button>
        </div>
      </form>
    </div>
  );
};

export default CaseCreator; 